import { createFileRoute } from "@tanstack/react-router";
import OutlineImportPage from "@/components/outline-import/OutlineImportPage";

export const Route = createFileRoute("/concepts/$conceptId/import/outline")({
  component: RouteComponent,
});

function RouteComponent() {
  const { conceptId } = Route.useParams();
  return <OutlineImportPage conceptId={conceptId} />;
}
